import { CALL_API, CONTENT_TYPE } from 'middlewares/api';
import { NEWTUBE_API_SERVER } from 'configs/url';

const FETCH_CHANGE_RECORD_REQUEST = 'foundation/mydata/educations/FETCH_CHANGE_RECORD_REQUEST';
const FETCH_CHANGE_RECORD_SUCCESS = 'foundation/mydata/educations/FETCH_CHANGE_RECORD_SUCCESS';
const FETCH_CHANGE_RECORD_FAIL = 'foundation/mydata/educations/FETCH_CHANGE_RECORD_FAIL';
const ADD_CHANGE_RECORD_REQUEST = 'foundation/mydata/educations/ADD_CHANGE_RECORD_REQUEST';
const ADD_CHANGE_RECORD_SUCCESS = 'foundation/mydata/educations/ADD_CHANGE_RECORD_SUCCESS';
const ADD_CHANGE_RECORD_FAIL = 'foundation/mydata/educations/ADD_CHANGE_RECORD_FAIL';

const REMOVE_CHANGE_RECORD_REQUEST = 'foundation/mydata/educations/REMOVE_CHANGE_RECORD_REQUEST';
const REMOVE_CHANGE_RECORD_SUCCESS = 'foundation/mydata/educations/REMOVE_CHANGE_RECORD_SUCCESS';
const REMOVE_CHANGE_RECORD_FAIL = 'foundation/mydata/educations/REMOVE_CHANGE_RECORD_FAIL';

export default function reducer(state = {
  isLoading: false,
  isLoaded: false,
  errorMessage: '',
  data: [],
}, action) {
  switch (action.type) {
    case FETCH_CHANGE_RECORD_REQUEST:
      return Object.assign({}, state, {
        isLoading: true,
        errorMessage: '',
        data: [],
      });
    case FETCH_CHANGE_RECORD_SUCCESS:
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
        data: action.response.data,
      });
    case FETCH_CHANGE_RECORD_FAIL:
      return Object.assign({}, state, {
        isLoading: false,
        isLoaded: true,
        errorMessage: '資料載入錯誤',
      });
    case REMOVE_CHANGE_RECORD_REQUEST:
      const newData = state.data.map((changeRecord) => {
        if (changeRecord.id === action.id) {
          return Object.assign({}, changeRecord, { currentStatus: '30' });
        }
        return changeRecord;
      });

      return Object.assign({}, state, {
        data: newData,
      });
    default:
      return state;
  }
}

export function fetchChangeRecords() {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}users/education/changeRecords?sort=CreateOn&asc=desc`,
      types: [FETCH_CHANGE_RECORD_REQUEST, FETCH_CHANGE_RECORD_SUCCESS, FETCH_CHANGE_RECORD_FAIL],
    },
  };
}

export function addChangeRecord(formData) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}users/education/changeRecords`,
      types: [ADD_CHANGE_RECORD_REQUEST, ADD_CHANGE_RECORD_SUCCESS, ADD_CHANGE_RECORD_FAIL],
      method: 'POST',
      params: formData,
      contentType: CONTENT_TYPE.FORM,
    },
  };
}

export function removeChangeRecord(recordId) {
  return {
    [CALL_API]: {
      url: `${NEWTUBE_API_SERVER}users/education/changeRecords/${recordId}/cancel`,
      types: [REMOVE_CHANGE_RECORD_REQUEST, REMOVE_CHANGE_RECORD_SUCCESS, REMOVE_CHANGE_RECORD_FAIL],
      method: 'PUT',
    },
    id: recordId,
  };
}



/** WEBPACK FOOTER **
 ** D:/a/1/s/Tube.Frontend/src/containers/App/screens/Foundation/screens/MyData/screens/CertificationAndEducationInfo/reducers/education/changeRecordsReducer.js
 **/